/** * * Asynchronously loads the component for
DeletionPolicy
* */ import { lazyLoad } from "utils/loadable";
export const DeletionPolicy = lazyLoad(
  () => import("./index"),
  (module) => module.DeletionPolicy
);
